import React, {FC} from 'react';
import {GxIcon} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';
import {useStoreon} from 'storeon/react';
import styles from '../../styles/index.module.scss';
import {SIDEBAR_TYPES} from '../../const';
import {ClockIcon, MinusIcon, MoneyIcon, PlusIcon} from '../../../../../../assets';
import {ARR_DEPOSITS_TYPE, TITLE_DEPOSIT_NUll} from '../../../../../../const';

interface IDepositComponent  {
    activeSideBarItem: number;
    clickItem: (deposit: Record<string, any>)=>void;
    activeItem: Record<string, any> | null;
    setCount:(e: number)=>void;
    count:number
}

const DepositComponent:FC<IDepositComponent> = ({activeSideBarItem,clickItem,activeItem,count,setCount}) => {
    const { depositListPattern } = useStoreon('depositListPattern');
    const list = activeSideBarItem === 2 
        ? [...depositListPattern[ARR_DEPOSITS_TYPE[activeSideBarItem]].rent_rates, ...depositListPattern[ARR_DEPOSITS_TYPE[activeSideBarItem]].tariff_rates]
        : depositListPattern[ARR_DEPOSITS_TYPE[activeSideBarItem]];
    const cn = cnBind.bind(styles);

    return (
        <div className={cn({
            list: list.length !== 0,
            'list--missing': list.length === 0
        })}>
            {list.length === 0 ?
                <div>
                    {`${TITLE_DEPOSIT_NUll[activeSideBarItem]} депозиты отсутсвуют...`}
                </div>
                :
                <>
                    {list.map((deposit: Record<string, any>) => {
                        return (
                            <div
                                key={deposit.id}
                                onClick={()=>clickItem(deposit)}
                                role='button'
                                tabIndex={0}
                                className={cn({
                                    'list__item': true,
                                    'list__item--active': activeItem?.id === deposit.id
                                })}
                            >
                                    {activeSideBarItem === SIDEBAR_TYPES.MONEY ?
                                        <div className={styles['container']}>
                                            <GxIcon src={MoneyIcon} className={styles['list__item_time--icon']}/>
                                            <p className={styles['list__item--title']}>{deposit.name}</p>
                                        </div>
                                    :
                                        <>
                                        <p className={styles['list__item--title']}>{(activeSideBarItem === SIDEBAR_TYPES.MONEY ? deposit.name : deposit.rate_name) ?? deposit.title}</p>
                                        <div className={styles['list__item_time']}>
                                            {/* <GxIcon src={MoneyIcon} className={styles['list__item_time--icon']}/> */}
                                            {/* <span className={styles['list__item_time--text']}> */}
                                            {/*    {Math.trunc(deposit.price).toLocaleString()}  &#8381; */}
                                            {/* </span> */}
                                            <GxIcon src={ClockIcon} className={styles['list__item_time--icon']}/>
                                            <span className={styles['list__item_time--text']}>
                                                {activeSideBarItem === SIDEBAR_TYPES.PIPE 
                                                    ? `${deposit.minutes} мин.` 
                                                    : deposit.rent_pay_count 
                                                        ? `${deposit.rent_pay_count} ap.`
                                                        : `${deposit.count_people} сет(ов)`
                                                }
                                            </span>
                                        </div>
                                        </>
                                    }
                                <div className={styles['list__item_info']}>
                                    <span className={styles['list__item_info--price']}>{Number(deposit.price).toLocaleString()}</span>
                                     {(activeItem?.id === deposit.id && activeSideBarItem !== SIDEBAR_TYPES.MONEY) &&
                                        <div className={styles['count']}>
                                          <button type='button' className={styles['count--btn']} disabled={count === 1} onClick={()=>setCount(count - 1)}>
                                            <GxIcon src={MinusIcon} className={styles['count--icon']}/>
                                          </button>
                                          <span className={styles['count--text']}>{count}</span>
                                          <button  type='button' className={styles['count--btn']} onClick={()=>setCount(count + 1)}>
                                            <GxIcon src={PlusIcon} className={styles['count--icon']}/>
                                          </button>
                                        </div>
                                     }
                                </div>
                            </div>
                        )
                    })}
                </>
            }
        </div>
    );
};

export default DepositComponent;